import app from '../app.first';
import $ from 'jquery';

app.RecruiterRequisitions = class extends app.Component {
	onReady() {
        let salaryInput = $('#job_salary');
        let salaryValue = $('#job_salary_value');
        let marketRelated = $('#is-market-related');
        let byMerchant = $('#is-by-merchant');
        let external = $('#externalCompanyInput');
        let showLogoField = false;

        checkState(marketRelated, [salaryInput, salaryValue]);

        marketRelated.change(() => {
            checkState(marketRelated, [salaryInput, salaryValue]);
        })

        function checkState (el, args) {
            var i;

            if (el.is(':checked')) {
                for (i = 0; i < args.length; i++) {
                    setDisabled(args[i]);
                }
            } else {
                for (i = 0; i < args.length; i++) {
                    setEnabled(args[i]);
                }
            }
        }

        function setDisabled (el) {
            el.attr('disabled', true);
            el.css('opacity', '.5');
        }

        function setEnabled (el) {
            el.attr('disabled', false);
            el.css('opacity', '1');
        }

        if (byMerchant.children("option:selected").val() == 1) {
            showLogoField = true;
        }

        if (showLogoField) {
            external.css('display', 'block');
        } else {
            external.css('display', 'none');
        }

        byMerchant.change(() => {
            if (byMerchant.children("option:selected").val() == 1) {
                external.css('display', 'block');
            } else {
                external.css('display', 'none');
            }
        })

	}
}